import PropTypes from "prop-types";
import React from "react";

import { ConnectedFetchDeviceController } from "./connected-fetch-device-controller";

function withFetchDeviceController(Wrapped) {
  return class WithFetchDeviceController extends React.PureComponent {
    static get propTypes() {
      return {
        deviceId: PropTypes.string,
      };
    }
    render() {
      const { deviceId } = this.props;

      return (
        <ConnectedFetchDeviceController deviceId={deviceId}>
          <Wrapped {...this.props} />
        </ConnectedFetchDeviceController>
      );
    }
  };
}

export { withFetchDeviceController };
